import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import { ReporteBOTContent } from './components/ReporteBOTContent';

export default function ReporteBOT() {
  return (
    <>
      <MainContent
        titulo='Reporte BOT'
        component={<ReporteBOTContent />}
        tableMaxWidth
      />
      <Outlet />
    </>
  );
}